<template>
  <div v-loading="loadingDispensation" class="prescription-dispense-view">
    <div
      v-if="!medicationRequest && fetchingMedicationRequest"
      v-loading="fetchingRequiredData"
      class="prescription-dispense-view__loader"
      element-loading-text="Cargando detalles de la prescripción" />
    <div v-if="medicationRequestError" class="prescription-dispense-view__error-message">
      <div class="alert alert-danger" role="alert">
        {{ medicationRequestError }}: [<strong>{{ medicationRequestId }}</strong>]
        <router-link to="/prescription-scan" tag="button" class="btn btn-primary">
          Intentar nuevamente
        </router-link>
      </div>
    </div>
    <template v-if="medicationRequest">
      <medication-request-related-users :practitioner="practitioner" :patient="patient" :legal-representative="legalRepresentative" />
      <div class="prescription-dispense-view__body">
        <div v-loading="loadingDispense" class="prescription-dispense-view__medication-list-container">
          <div class="prescription-dispense-view__sub-title">
            <h4>Medicamento(s) Prescrito(s) <strong>{{ medicationRequest.contained.length }}</strong></h4>
          </div>
          <medication-list
            v-if="!loadingDispense"
            type="medication-request"
            :medications="medicationRequest.contained"
            :retain-prescription="retainPrescription"
            :exist-dispenses="existDispenses"
            :fetching-ref-sets="fetchingRefSets"
            @medication-dispense="handleMedicationRequestSelected"
            @medication-dispense-edit="handleMedicationDispenseEdit"
            @medication-dispense-delete="handleMedicationDispenseDelete"
            @show-previous-dispenses="handleShowPreviousDispenses" />

          <!-- <div v-if="!disableRecipe" class="prescription-dispense-view__medication-list-container">
            <div class="prescription-dispense-view__sub-title">
              <h4>Medicamento(s) Dispensado(s)</h4>
            </div>
            <medication-list
              type="medication-dispense"
              :medications="medicationDispenses"
              :processing-medication-dispenses="processingMedicationDispenses"
              :disable-recipe="disableRecipe"
              @medication-dispense="handleMedicationDispenseSelected"
              @delete-medications="handleDeleteMedications"
              @save-medication-dispense="handleSaveMedicationDispense" />
          </div> -->
        </div>
        <div class="prescription-dispense-view__medication-list-container">
          <div class="prescription-dispense-view__sub-title">
            <h4>Prescripción</h4>
            <a class="mb-1" href="#" @click.prevent="handleClickShowPrescription">
              Ampliar<i class="ml-2 fas fa-search-plus" />
            </a>
          </div>
          <div class="prescription-dispense-view__preview">
            <prescription-preview
              v-if="medicationRequestId"
              :prescription-id="medicationRequestId"
              height="500px"
              :show-print="false" />
          </div>
        </div>
      </div>
      <div class="d-flex p-2 justify-content-center prescription-dispense-view__footer">
        <button
          type="button"
          class="btn btn-danger"
          :disabled="!hasMedicationDispenses || disableRecipe"
          @click.prevent="handleSaveMedicationDispense">
          Confirmar dispensación
        </button>
      </div>
    </template>
    <prescription-preview-dialog
      :visible="showPrescriptionDialog"
      :prescription-id="medicationRequestId"
      @close-dialog="showPrescriptionDialog = false" />
    <el-dialog
      title="Dispensación de Medicamento"
      width="80%"
      custom-class="medication-dispense-form__dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible="showMedicationDispenseDialog"
      :before-close="handleCloseMedicationDispenseDialog">
      <medication-dispense-form
        v-if="activeMedicationRequest || activeMedicationDispense"
        v-loading="loadingSubmit"
        :medication-dispense="activeMedicationDispense"
        :medication-request="activeMedicationRequest"
        :errors="activeMedicationDispenseErrors"
        :patient="patient"
        @submit="handleMedicationDispenseFormSubmit" />
    </el-dialog>
    <el-dialog
      title="Historial de Dispensaciones"
      width="80%"
      custom-class="medication-request-dispense-history__dialog"
      :visible="showMedicationRequestDispenseHistoryDialog"
      :before-close="handleCloseMedicationRequestDispenseHistoryDialog">
      <medication-request-dispense-history
        v-if="activeMedicationRequestDispenseHistory"
        :medication-request="activeMedicationRequestDispenseHistory" />
    </el-dialog>

    <el-dialog
      title="Error"
      width="60%"
      :before-close="handleCloseDispenseError"
      custom-class="medication-request-form__dialog"
      :visible="dispenseError != ''">
      {{ dispenseError }}
    </el-dialog>
  </div>
</template>

<script>
import _cloneDeep from 'lodash/cloneDeep';
import _get from 'lodash/get';
import _uniq from 'lodash/uniq';
import _find from 'lodash/find';
import nanoId from '@/helpers/nanoid';
import MedicationRequestRelatedUsers from '@/components/medication/MedicationRequestRelatedUsers';
import MedicationList from '@/components/medication/MedicationList';
import PrescriptionPreviewDialog from '@/components/prescription/PrescriptionPreviewDialog';
import MedicationDispenseForm from '@/components/medication/MedicationDispenseForm';
import MedicationRequestDispenseHistory from '@/components/medication/MedicationRequestDispenseHistory';
import PrescriptionPreview from '@/components/prescription/PrescriptionPreview';

const LOCATION_TYPE = 'PHARM';

export default {
  name: 'PrescriptionDispenseView',
  components: {
    MedicationRequestRelatedUsers,
    MedicationList,
    PrescriptionPreviewDialog,
    MedicationDispenseForm,
    MedicationRequestDispenseHistory,
    PrescriptionPreview
  },
  data() {
    return {
      practitioner: {},
      patient: {},
      legalRepresentative: {},
      medicationRequestId: this.$route.params.medicationRequestId.replace(/-/g, ''),
      medicationRequest: null,
      medicationDispenses: [],
      medicationRequestError: null,
      fetchingMedicationRequest: true,
      fetchingMedicationDispenseMetadata: false,
      showPrescriptionDialog: false,
      showMedicationDispenseDialog: false,
      showMedicationRequestDispenseHistoryDialog: false,
      activeMedicationRequestDispenseHistory: null,
      activeMedicationRequest: null,
      activeMedicationDispense: null,
      activeMedicationDispenseErrors: {},
      processingMedicationDispenses: [],
      activePreviousDispenses: null,
      medicationDispensesSaved: 0,
      medicationDispensesBatch: 0,
      dispenseError: '',
      loadingDispense: false,
      loadingSubmit: false,
      loadingDispensation: false,
      refsets: [],
      fetchingRefSets : false
    };
  },
  computed: {
    hasMedicationDispenses() {
      return this.medicationDispenses.length;
    },
    fetchingRequiredData() {
      return this.fetchingMedicationRequest || this.fetchingMedicationDispenseMetadata || this.fetchingRefSets;
    },
    medicationRequestReferences() {
      return _get(this.medicationRequest, 'contained', []).map(m => m.id);
    },
    medicationDispenseReferences() {
      return _uniq(this.medicationDispenses.map(m => _get(m, 'data.authorizingPrescription.reference', '').split('/').pop()));
    },
    dispensedDetailsRoute() {
      return `/prescription-dispense/${this.$route.params.medicationRequestId}/dispense-group/${this.groupId}`;
    },
    organizationLocation() {
      const organization = this.$store.getters.activeOrganization;
      return {
        type: LOCATION_TYPE,
        address: organization.address,
        name: organization.name,
        identifier: organization.rut
      };
    },
    existDispenses() {
      try {
        return this.medicationRequest.contained[0].medicationDispenses.length > 0;
      } catch (e) {
        return false;
      }
    },
    retainPrescription() {

      if (this.fetchingRefSets){
        return false;
      }

      try {
        return this.medicationRequest.contained[0].data.retainPrescription;
      } catch (e) {
        return false;
      }
    },
    disableRecipe() {
      return this.retainPrescription && this.existDispenses;
    }
  },
  created() {
    this.groupId = nanoId();
    this.fetchMedicationDispenseMetadata();
    this.fetchMedicationRequest();
  },
  methods: {
    fetchMedicationRequest() {
      this.medicationRequestError = null;
      this.$store.dispatch('fetchMedicationRequestDetails', this.medicationRequestId)
        .then(response => {
          this.medicationRequest = response.data.medicationRequest;
          this.practitioner = response.data.practitioner;
          this.patient = response.data.patient;
          this.legalRepresentative = response.data.legalRepresentative;
          const medicationReference = this.medicationRequest.contained[0].data.medicationReference;
          if (!this.retainPrescription){
            this.fetchRefs(medicationReference);
          }
        })
        .catch(e => {
          this.medicationRequestError = e.message;
        })
        .finally(() => {
          this.fetchingMedicationRequest = false;
        });
    },
    fetchMedicationDispenseMetadata() {
      this.fetchingMedicationDispenseMetadata = true;
      this.$store.dispatch('fetchMedicationDispenseMetadata')
        .finally(() => {
          this.fetchingMedicationDispenseMetadata = false;
        });
    },
    handleClickShowPrescription() {
      this.showPrescriptionDialog = true;
    },
    handleCloseMedicationRequestDispenseHistoryDialog() {
      this.showMedicationRequestDispenseHistoryDialog = false;
      this.activeMedicationRequestDispenseHistory = null;
    },
    handleCloseMedicationDispenseDialog() {
      this.showMedicationDispenseDialog = false;
      this.activeMedicationRequest = null;
      this.activeMedicationDispense = null;
      this.activeMedicationDispenseErrors = {};
    },
    handleMedicationRequestSelected(medication) {
      this.showMedicationDispenseDialog = true;
      this.activeMedicationRequest = _cloneDeep(medication.data);
      this.activeMedicationDispense = null;
      this.activeMedicationDispenseErrors = {};
    },
    handleMedicationDispenseEdit(medication) {
      this.showMedicationDispenseDialog = true;
      this.activeMedicationRequest = _cloneDeep(medication.data);
      this.activeMedicationDispense = _cloneDeep(medication.dispense.data);
      this.activeMedicationDispenseErrors = {};
    },
    handleMedicationDispenseSelected(medication) {
      this.showMedicationDispenseDialog = true;
      this.activeMedicationRequest = this.medicationRequest.contained.find(m => m.id === medication.medicationRequestId).data;
      this.activeMedicationDispense = _cloneDeep(medication.data);
      this.activeMedicationDispenseErrors = _cloneDeep(_get(medication, 'errors', {}));
    },
    handleMedicationDispenseDelete(medication) {
      this.loadingDispense = true;
      let medicatioRequestIndex = this.medicationRequest.contained.findIndex(m => m.id === medication.id);
      this.medicationRequest.contained[medicatioRequestIndex].dispense = null;

      let medicationDispenseIndex = this.medicationDispenses.findIndex(d => d.medicationRequestId === medication.id);
      this.medicationDispenses.splice(medicationDispenseIndex, 1);
      setTimeout(() => {
        this.loadingDispense = false;
      }, 500);
    },
    handleMedicationDispenseFormSubmit(medicationDispenseData, medicationRequestId) {
      this.loadingSubmit = true;
      const medicationDispense = {
        id: medicationDispenseData.id,
        medicationRequestId: medicationRequestId,
        data: medicationDispenseData
      };

      const errors = this.validateMedicationDispense(medicationDispense);

      if (!errors) {
        this.loadingDispense = true;
        let existingIndex = this.medicationDispenses.findIndex(m => m.id === medicationDispense.id);
        if (existingIndex < 0) {
          this.medicationDispenses.push(medicationDispense);
        } else {
          this.medicationDispenses.splice(existingIndex, 1, medicationDispense);
        }

        let MedicatioRequestIndex = this.medicationRequest.contained.findIndex(m => m.id === medicationRequestId);
        this.medicationRequest.contained[MedicatioRequestIndex].dispense = medicationDispense;

        this.showMedicationDispenseDialog = false;
        this.activeMedicationRequest = null;
        this.activeMedicationDispense = null;
        setTimeout(() => {
          this.loadingDispense = false;
        }, 500);
      } else {
        this.activeMedicationDispenseErrors = errors;
      }
      setTimeout(() => {
        this.loadingSubmit = false;
      }, 300);
    },
    handleDeleteMedications(selectedMedicationsIds, type) {
      for (let selectedMedicationId of selectedMedicationsIds) {
        let index = this.medicationDispenses.findIndex(m => m.id === selectedMedicationId);
        this.medicationDispenses.splice(index, 1);
      }
    },
    handleSaveMedicationDispense() {
      if (this.loadingDispensation) return;
      this.loadingDispensation = true;
      this.dispenseError = '';
      this.medicationDispensesSaved = 0;
      this.medicationDispensesBatch = 0;
      this.medicationDispenses.forEach(medicationDispense => {
        if (medicationDispense.status === 'success') {
          this.loadingDispensation = false;
          return;
        }
        this.medicationDispensesBatch++;
        this.processingMedicationDispenses.push(medicationDispense.id);
        this.$store.dispatch('saveMedicationDispense',
          {
            medicationDispense,
            groupId: this.groupId,
            location: this.organizationLocation
          })
          .then(response => {
            this.medicationProcessed(response.medicationDispenseId, 'success');
            this.loadingDispensation = false;
          })
          .catch(e => {
            if (e.status == 500) {
              this.processingMedicationDispenses = [];
              this.medicationDispensesBatch = 0;
              this.dispenseError = e.message;
              this.loadingDispensation = false;
              return;
            }
            this.medicationProcessed(e.medicationDispenseId, 'error', e);
          });
      });
    },
    medicationProcessed(medicationDispenseId, status, error) {
      this.medicationDispensesSaved++;
      let index = this.processingMedicationDispenses.findIndex(id => id === medicationDispenseId);
      if (index >= 0) {
        this.processingMedicationDispenses.splice(index, 1);
      }
      this.medicationDispenses = _cloneDeep(this.medicationDispenses).map(medicationDispense => {
        if (medicationDispense.id === medicationDispenseId) {
          medicationDispense.status = status;
          medicationDispense.errors = status === 'error' ? _get(error, 'details', {}) : null;
        }
        return medicationDispense;
      });

      if (this.medicationDispensesSaved === this.medicationDispensesBatch) {
        this.handleConfirmationMessage();
      }
    },
    handleShowPreviousDispenses(medication) {
      this.showMedicationRequestDispenseHistoryDialog = true;
      this.activeMedicationRequestDispenseHistory = _cloneDeep(medication);
    },
    handleConfirmationMessage() {
      let allMedicationDispensed = true;
      this.medicationRequest.contained.forEach((item) => {
        let included = _find(this.medicationDispenses, (dispensing) => dispensing.medicationRequestId === item.id);
        if (!item.medicationDispenses && !included) {
          allMedicationDispensed = false;
        }
      });

      if (allMedicationDispensed) {
        this.$router.push(this.dispensedDetailsRoute);
      } else {
        const h = this.$createElement;
        this.$msgbox({
          title: 'Medicamentos Dispensados',
          message: h('p', null, [
            h('h6', null, 'Aun hay medicamentos sin dispensar'),
            h('h6', null, '¿Desea finalizar la dispensación?')
          ]),
          showCancelButton: true,
          confirmButtonText: 'Finalizar Dispensación',
          cancelButtonText: 'Continuar la Dispensación'
        })
          .then(r => {
            this.$router.push(this.dispensedDetailsRoute);
          })
          .catch(e => {});
      }
    },
    validateMedicationDispense(medicationDispense) {
      const errors = {};

      if (!_get(medicationDispense, 'data.medicationReference.reference')) {
        errors['medication-reference'] = 'Debe seleccionar un medicamento a dispensar';
      }

      if (_get(medicationDispense, 'data.substitution.wasSubstituted') && !_get(medicationDispense, 'data.substitution.reason')) {
        errors['substitution-reason'] = 'Debe especificar la razón de la sustitución';
      }

      if (!_get(medicationDispense, 'data.quantity.value') || isNaN(_get(medicationDispense, 'data.quantity.value')) || !_get(medicationDispense, 'data.quantity.code')) {
        errors['quantity'] = 'Debe especificar una unidad a dispensar válida';
      }

      return Object.keys(errors).length ? errors : null;
    },
    handleCloseDispenseError() {
      this.dispenseError = '';
    },
    async fetchRefs(clinicalMedication, callback) {
      this.fetchingRefSets = true;
      return this.$store.dispatch('fetchRefsMedication', clinicalMedication)
        .then(response => {
          this.refsets = response.data;

          this.refsets.forEach(ref => {
            if (!ref || !ref.refset) {
              return;
            }
            if (ref.refset.nombreRefSet == 'control existencia') {
              this.medicationRequest.contained[0].data.retainPrescription = true;
            }
          });
        })
        .finally(() => {
          this.fetchingRefSets = false;
        });
    },
  }
};
</script>

<style lang="scss">
.prescription-dispense-view {
  &__preview{
    border: 1px solid #eee;
    border-radius: 4px;
  }
  &__loader {
    min-height: 75vh;
  }

  &__error-message {
    margin-top: $--spacing-6*2;
  }

  &__body {
    background: $--color-white;
    display: flex;
    @media (max-width: 500px){
      flex-direction: column;
    }
  }

  &__medication-list-container {
    flex: 1;
    margin: $--spacing-4;
  }

  &__sub-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    a {
      color: $--color-red;
      cursor: pointer;
    }
  }
}
</style>
